import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getVendorsList } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import formatDateAndTime from "../../common/formatDateAndTime";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import HeicPreview from "../../common/HeicPreview";
import { FileText, FileVideo, FileImage, File } from "lucide-react";

function createData(
  attachments,
  workType,
  serviceDate,
  odoAtService,
  nextInspectionOdo,
  nextChangePredictedOdo,
  totalCost,
  notes,
  issueId,
  vendorId,
  createdAt,
  partId,
  partSource,
  brandName,
  serialNumber,
  partCost,
  partattachments,
  rawData,
) {
  return {
    attachments,
    workType,
    serviceDate,
    odoAtService,
    nextInspectionOdo,
    nextChangePredictedOdo,
    totalCost,
    notes,
    issueId,
    vendorId,
    createdAt,
    partId,
    partSource,
    brandName,
    serialNumber,
    partCost,
    partattachments,
    rawData,
  };
}

const steps = ["Service Log Details", "Clutch Part Details"];

const Myclutch = ({ handleImageOpen, selectedRow }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const catalogValues = JSON.parse(localStorage.getItem("catalogValues"));

  const clutchPartName = catalogValues?.clutchPartName || {};
  delete clutchPartName?.inverted;
  const clutchPartSource = catalogValues?.clutchPartSource || {};
  delete clutchPartSource?.inverted;
  const clutchWorkType = catalogValues?.clutchWorkType || {};
  delete clutchWorkType?.inverted;
  const [activeStep, setActiveStep] = useState(0);
  const [hideTextfields, setHideTestFields] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [clutchLogs, setClutchLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [myIssues, setMyIssuesDetails] = useState([]);

  const getVehicleIssues = async (vehicleID) => {
    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicleissues?limit=${200}&offset=${0}&vehicleId=${vehicleID}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setMyIssuesDetails(data?.entities?.rows || []);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVendorListAPI();
  }, []);

  useEffect(() => {
    if (selectedRow?.id) {
      getVehicleIssues(selectedRow.id);
    }
  }, [selectedRow]);

  const getVendorListAPI = async (value) => {
    const apiDetails = await getVendorsList(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVendors(data?.entities?.rows || []);
  };

  const [form, setForm] = useState({
    serviceDetails: {
      clutchWorkType: null,
      serviceDate: null,
      odoAtService: null,
      vendorId: null,
      notes: null,
      issueId: null,
      attachments: [],
      totalCost: null,
    },
    parts: [
      {
        partId: null,
        partSource: null,
        brandName: null,
        serialNumber: null,
        attachments: [],
      },
    ],
  });

  const handleServiceAttachment = async (files) => {
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded;

    setForm((prev) => ({
      ...prev,
      serviceDetails: {
        ...prev.serviceDetails,
        attachments: [...(prev.serviceDetails.attachments || []), ...uploaded],
      },
    }));
  };

  const handlePartAttachment = async (index, files) => {
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded;

    const updated = [...form.parts];

    updated[index].attachments = [
      ...(updated[index].attachments || []),
      ...uploaded,
    ];

    setForm((prev) => ({
      ...prev,
      parts: updated,
    }));
  };

  // service field change
  const handleServiceChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      serviceDetails: {
        ...prev.serviceDetails,
        [field]: value,
      },
    }));
  };

  // part change
  const handlePartChange = (index, field, value) => {
    const updated = [...form.parts];
    updated[index][field] = value;

    setForm((prev) => ({
      ...prev,
      parts: updated,
    }));
  };

  // add part
  const addPartRow = () => {
    setForm((prev) => ({
      ...prev,
      parts: [
        ...prev.parts,
        {
          partId: "",
          partSource: "",
          brandName: "",
          serialNumber: "",
          partCost: "",
        },
      ],
    }));
  };

  // remove part
  const removePartRow = (index) => {
    const updated = [...form.parts];
    updated.splice(index, 1);

    setForm((prev) => ({
      ...prev,
      parts: updated,
    }));
  };

  // submit
  const handleSubmit = async () => {
    const { serviceDetails, parts } = form;

    // -------- Service Details Validation --------
    if (!serviceDetails?.serviceDate) {
      return toast.error("Please select Service Date");
    }

    if (!serviceDetails?.odoAtService) {
      return toast.error("Please enter Odometer at Service");
    }

    if (!serviceDetails?.clutchWorkType) {
      return toast.error("Please select Clutch Work Type");
    }

    // if (!serviceDetails?.issueId) {
    //   return toast.error("Please select Issue");
    // }

    // -------- Parts Validation --------
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];

      if (!part.partId) {
        return toast.error(`Please select Part in row ${i + 1}`);
      }

      if (!part.partSource) {
        return toast.error(`Please select Part Source in row ${i + 1}`);
      }

      if (!part.brandName) {
        return toast.error(`Please enter Brand Name in row ${i + 1}`);
      }

      if (!part.serialNumber) {
        return toast.error(`Please enter Serial Number in row ${i + 1}`);
      }

      if (!part.partCost) {
        return toast.error(`Please enter Part Cost in row ${i + 1}`);
      }
    }

    // -------- Payload --------
    const payload = {
      vehicleId: selectedRow?.id,
      serviceDate: serviceDetails.serviceDate,
      odoAtService: Number(serviceDetails.odoAtService),
      workType: serviceDetails.clutchWorkType,
      notes: serviceDetails.notes,
      issueId: serviceDetails.issueId,
      totalCost: serviceDetails?.totalCost,
      vendorId: serviceDetails?.vendorId,
      attachments: JSON.stringify(serviceDetails?.attachments || []),
      clutchPartsDetailsList: parts,
    };

    try {
      const res = await fetch(`${apiUrl}/api/clutchservicelogs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("Clutch Log Added Successfully 🎉");

        setForm({
          serviceDetails: {},
          parts: [
            {
              partId: "",
              partSource: "",
              brandName: "",
              serialNumber: "",
              partCost: "",
              attachments: [],
            },
          ],
        });

        setActiveStep(0);
        await getClutchLogs(selectedRow?.id);
      } else {
        toast.error(data?.msg);
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    if (selectedRow?.id) {
      getClutchLogs(selectedRow?.id);
    }
  }, [selectedRow]);

  const getClutchLogs = async (vehicleID, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/clutchservicelogs?limit=${limit}&offset=${offset}&vehicleId=${vehicleID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setClutchLogs(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const rows =
    (clutchLogs &&
      clutchLogs?.map((item) =>
        createData(
          item?.attachments,
          clutchWorkType[item?.workType],
          item?.serviceDate,
          item?.odoAtService,
          item?.nextInspectionOdo,
          item?.nextChangePredictedOdo,
          item?.totalCost,
          item?.notes,
          myIssues.filter((issue) => issue?.id === item?.issueId)[0]?.code,
          vendors.filter((vendor) => vendor?.id === item?.vendorId)[0]?.name,
          formatDateAndTime(item?.createdAt),
          item?.clutchPartsDetailsList?.partId,
          clutchPartSource[item?.clutchPartsDetailsList?.partSource],
          item?.clutchPartsDetailsList?.brandName,
          item?.clutchPartsDetailsList?.serialNumber,
          item?.clutchPartsDetailsList?.partCost,
          item?.clutchPartsDetailsList?.attachments,
          item,
        ),
      )) ||
    [];

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "webp", "gif", "avif", "svg"].includes(ext))
      return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (ext === "pdf") return "pdf";
    if (ext === "heic") return "heic";
    if (["doc", "docx", "xls", "xlsx"].includes(ext)) return "doc";

    return "file";
  };

  return (
    <>
      <div className="flex justify-between p-6 mt-6">
        <h1 className="text-lg font-semibold">Add Clutch Details</h1>

        {hideTextfields ? (
          <CloseIcon
            onClick={() => setHideTestFields(false)}
            className="cursor-pointer"
          />
        ) : (
          <AddCircleOutlineIcon
            onClick={() => setHideTestFields(true)}
            className="cursor-pointer"
          />
        )}
      </div>

      {hideTextfields && (
        <div className="p-6">
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((step) => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* STEP 1 */}

          {activeStep === 0 && (
            <div className="grid grid-cols-3 gap-6 mt-6">
              <FormControl>
                <InputLabel>Clutch Work Type</InputLabel>
                <Select
                  value={form.serviceDetails.clutchWorkType}
                  label="Clutch Work Type"
                  onChange={(e) =>
                    handleServiceChange("clutchWorkType", e.target.value)
                  }
                >
                  {Object.entries(clutchWorkType).map(([k, v]) => (
                    <MenuItem key={k} value={k}>
                      {v}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                type="date"
                label="Service Date"
                InputLabelProps={{ shrink: true }}
                value={form.serviceDetails.serviceDate}
                onChange={(e) =>
                  handleServiceChange("serviceDate", e.target.value)
                }
              />

              <TextField
                label="Service Interval (Odometer Limit)"
                value={form.serviceDetails.odoAtService}
                onChange={(e) =>
                  handleServiceChange("odoAtService", e.target.value)
                }
              />

              <FormControl fullWidth>
                <InputLabel>Select Vendor</InputLabel>
                <Select
                  value={form.serviceDetails.vendorId}
                  label="Select Vendor"
                  onChange={(e) =>
                    handleServiceChange("vendorId", e.target.value)
                  }
                >
                  {vendors?.map((vendor) => (
                    <MenuItem key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>Select Issue</InputLabel>
                <Select
                  value={form.serviceDetails.issueId}
                  label="Select Vendor"
                  onChange={(e) =>
                    handleServiceChange("issueId", e.target.value)
                  }
                >
                  {myIssues?.map((issue) => (
                    <MenuItem key={issue.id} value={issue.id}>
                      {issue.code}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                label="Total Cost"
                value={form.serviceDetails.totalCost}
                onChange={(e) =>
                  handleServiceChange("totalCost", e.target.value)
                }
              />

              <TextField
                label="Notes"
                value={form.serviceDetails.notes}
                onChange={(e) => handleServiceChange("notes", e.target.value)}
              />

              <div className="col-span-3">
                <label className="font-semibold mb-2 block">
                  Service Attachments
                </label>

                <Button component="label" variant="outlined">
                  Upload Files
                  <input
                    hidden
                    type="file"
                    multiple
                    onChange={(e) => handleServiceAttachment(e.target.files)}
                  />
                </Button>
                <div className="flex gap-3 mt-3 flex-wrap">
                  {form.serviceDetails.attachments?.map((img, i) => (
                    <img
                      key={i}
                      src={img?.url}
                      className="w-20 h-20 object-cover rounded border"
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* STEP 2 */}

          {activeStep === 1 && (
            <Table className="mt-6">
              <TableHead>
                <TableRow>
                  <TableCell>Part Name</TableCell>
                  <TableCell>Source</TableCell>
                  <TableCell>Brand</TableCell>
                  <TableCell>Part Cost</TableCell>
                  <TableCell>Serial Number</TableCell>
                  <TableCell>Attachments</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>

              <TableBody>
                {form.parts.map((part, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Select
                        value={part.partId}
                        onChange={(e) =>
                          handlePartChange(index, "partId", e.target.value)
                        }
                      >
                        {Object.entries(clutchPartName).map(([k, v]) => (
                          <MenuItem key={k} value={k}>
                            {v}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell>

                    <TableCell>
                      <Select
                        value={part.partSource}
                        onChange={(e) =>
                          handlePartChange(index, "partSource", e.target.value)
                        }
                      >
                        {Object.entries(clutchPartSource).map(([k, v]) => (
                          <MenuItem key={k} value={k}>
                            {v}
                          </MenuItem>
                        ))}
                      </Select>
                    </TableCell>

                    <TableCell>
                      <TextField
                        value={part.brandName}
                        onChange={(e) =>
                          handlePartChange(index, "brandName", e.target.value)
                        }
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                        value={part.partCost}
                        onChange={(e) =>
                          handlePartChange(index, "partCost", e.target.value)
                        }
                      />
                    </TableCell>

                    <TableCell>
                      <TextField
                        value={part.serialNumber}
                        onChange={(e) =>
                          handlePartChange(
                            index,
                            "serialNumber",
                            e.target.value,
                          )
                        }
                      />
                    </TableCell>

                    <TableCell>
                      <Button component="label" variant="outlined" size="small">
                        Upload
                        <input
                          hidden
                          type="file"
                          multiple
                          onChange={(e) =>
                            handlePartAttachment(index, e.target.files)
                          }
                        />
                      </Button>

                      <div className="flex gap-2 mt-2 flex-wrap">
                        {part.attachments?.map((img, i) => (
                          <img
                            key={i}
                            src={img?.url}
                            className="w-14 h-14 object-cover rounded"
                          />
                        ))}
                      </div>
                    </TableCell>

                    <TableCell>
                      <Button
                        color="error"
                        onClick={() => removePartRow(index)}
                      >
                        Remove
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}

          <div className="flex justify-end gap-4 mt-6">
            {activeStep > 0 && (
              <Button onClick={() => setActiveStep(activeStep - 1)}>
                Back
              </Button>
            )}

            {activeStep < steps.length - 1 && (
              <Button
                variant="contained"
                onClick={() => setActiveStep(activeStep + 1)}
              >
                Next
              </Button>
            )}

            {activeStep === steps.length - 1 && (
              <Button variant="contained" onClick={handleSubmit}>
                Submit
              </Button>
            )}
          </div>

          {activeStep === 1 && (
            <Button className="mt-4" variant="outlined" onClick={addPartRow}>
              + Add Part
            </Button>
          )}
        </div>
      )}

      <div className="p-4">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Attachments & Part Details</TableCell>
              <TableCell>Work Type</TableCell>
              <TableCell>Service Date</TableCell>
              <TableCell>Kilometer Limit for Service</TableCell>
              <TableCell>Next Inspection Odometer</TableCell>
              <TableCell>Next Change Prediction Odometer</TableCell>
              <TableCell>Total Cost</TableCell>
              <TableCell>Notes</TableCell>
              {/* <TableCell>Issue Id</TableCell> */}
              {/* <TableCell>Vendor Name</TableCell> */}
              <TableCell>Action</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length ? (
              rows.map((r, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={() => setOpen(open === index ? -1 : index)}
                      >
                        {open === index ? (
                          <KeyboardArrowUpIcon />
                        ) : (
                          <KeyboardArrowDownIcon />
                        )}
                      </IconButton>
                    </TableCell>
                    <TableCell>{r.workType}</TableCell>
                    <TableCell>{r.serviceDate}</TableCell>
                    <TableCell>{r.odoAtService}</TableCell>
                    <TableCell
                      style={{
                        color: "green",
                        fontWeight: "bold",
                      }}
                    >
                      {r.nextInspectionOdo}
                    </TableCell>
                    <TableCell>{r.nextChangePredictedOdo}</TableCell>
                    <TableCell
                      style={{
                        backgroundColor: r.totalCost
                          ? "lightgreen"
                          : "lightcoral",
                        color: "black", // optional, for text readability
                      }}
                    >
                      {r.totalCost}
                    </TableCell>
                    <TableCell>{r.notes}</TableCell>
                    {/* <TableCell>{r.issueId}</TableCell> */}
                    {/* <TableCell>{r.vendorId}</TableCell> */}
                    {r?.rawData?.serviceLogId &&
                    r?.rawData?.serviceLogId !== 0 ? (
                      <TableCell>
                        <Button
                          onClick={() => {
                            const navigate = `/workorder?orderid=${r?.rawData?.serviceLogId}&display=true`;
                            window.open(navigate, "_blank");
                          }}
                        >
                          View
                        </Button>
                      </TableCell>
                    ) : null}
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan={9} sx={{ p: 0 }}>
                      <Collapse in={open === index}>
                        <Box>
                          <TableCell>
                            <div className="flex gap-2 flex-wrap">
                              {r?.attachments &&
                                JSON.parse(r?.attachments)?.map(
                                  (item, index) => {
                                    const url =
                                      typeof item === "string"
                                        ? item
                                        : item?.url;
                                    if (!url) return null;

                                    const type = getFileType(url);

                                    return (
                                      <div
                                        key={index}
                                        className="border rounded-xl p-3 shadow hover:shadow-lg transition bg-white flex flex-col items-center justify-between gap-3"
                                      >
                                        {/* Preview */}
                                        <div
                                          onClick={() => {
                                            handleImageOpen(url);
                                          }}
                                          className="flex items-center justify-center"
                                        >
                                          {type === "image" && (
                                            <img
                                              src={url}
                                              alt={"Preview"}
                                              className="w-28 h-24 object-cover rounded-lg cursor-pointer"
                                            />
                                          )}

                                          {type === "heic" && (
                                            <div>
                                              <HeicPreview
                                                url={url}
                                                alt={"Preview"}
                                                className="w-28 h-24 object-cover rounded-lg cursor-pointer"
                                              />
                                            </div>
                                          )}

                                          {type === "video" && (
                                            <video
                                              src={url}
                                              controls
                                              className="w-28 h-24 rounded-lg"
                                            />
                                          )}

                                          {type === "pdf" && (
                                            <FileText
                                              size={36}
                                              className="text-red-600"
                                            />
                                          )}

                                          {type === "doc" && (
                                            <File
                                              size={36}
                                              className="text-blue-600"
                                            />
                                          )}

                                          {type === "file" && (
                                            <FileImage
                                              size={36}
                                              className="text-gray-600"
                                            />
                                          )}
                                        </div>

                                        <p>{item?.fileExt}</p>

                                        {/* Download Button */}
                                        <a
                                          href={url}
                                          target="_blank"
                                          download
                                          className="w-full text-center text-sm font-medium px-3 py-1.5 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-800 transition"
                                        >
                                          ⬇ Download
                                        </a>
                                      </div>
                                    );
                                  },
                                )}
                            </div>
                          </TableCell>
                        </Box>

                        <Box
                          sx={{
                            p: 3,
                            backgroundColor: "#cde1f7",
                            borderRadius: "10px",
                            border: "1px solid #595a5e",
                            margin: "10px",
                          }}
                        >
                          {clutchLogs[index]?.clutchPartsDetailsList ? (
                            <Table size="small" className="border">
                              <TableHead
                                sx={{
                                  backgroundColor: "#f1f5f9",
                                }}
                              >
                                <TableRow>
                                  <TableCell>
                                    <b>Part Name</b>
                                  </TableCell>
                                  <TableCell>
                                    <b>Part Source</b>
                                  </TableCell>
                                  <TableCell>
                                    <b>Brand Name</b>
                                  </TableCell>
                                  <TableCell>
                                    <b>Serial Number</b>
                                  </TableCell>
                                  <TableCell>
                                    <b>Part Cost</b>
                                  </TableCell>
                                  <TableCell>
                                    <b>Attachments</b>
                                  </TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {(Array.isArray(
                                  clutchLogs[index]?.clutchPartsDetailsList,
                                )
                                  ? clutchLogs[index]?.clutchPartsDetailsList
                                  : clutchLogs[index]?.clutchPartsDetailsList
                                    ? [
                                        clutchLogs[index]
                                          ?.clutchPartsDetailsList,
                                      ]
                                    : []
                                ).map((part, i) => (
                                  <TableRow key={i}>
                                    <TableCell>
                                      {clutchPartName[part.partId] || "-"}
                                    </TableCell>

                                    <TableCell>
                                      {clutchPartSource[part.partSource] || "-"}
                                    </TableCell>

                                    <TableCell>
                                      {part.brandName || "-"}
                                    </TableCell>

                                    <TableCell>
                                      {part.serialNumber || "-"}
                                    </TableCell>

                                    <TableCell>
                                      {part.partCost || "-"}
                                    </TableCell>

                                    <TableCell>
                                      <div className="flex gap-2 flex-wrap">
                                        {(() => {
                                          let attachments = [];

                                          try {
                                            attachments =
                                              typeof part?.attachments ===
                                              "string"
                                                ? JSON.parse(part.attachments)
                                                : part?.attachments || [];
                                          } catch (error) {
                                            attachments = [];
                                          }

                                          return Array.isArray(attachments) &&
                                            attachments.length > 0 ? (
                                            attachments.map((img, j) => (
                                              <img
                                                key={j}
                                                src={img?.url}
                                                alt={
                                                  img?.fileName || "attachment"
                                                }
                                                onClick={() =>
                                                  handleImageOpen(img)
                                                }
                                                className="w-16 h-16 object-cover rounded border cursor-pointer"
                                              />
                                            ))
                                          ) : (
                                            <Typography
                                              variant="body2"
                                              color="error"
                                            >
                                              No Attachments
                                            </Typography>
                                          );
                                        })()}
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          ) : (
                            <Typography color="error">
                              No Parts Found
                            </Typography>
                          )}
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={10} // 👈 adjust based on total columns
                  align="center"
                  sx={{ fontWeight: "bold", py: 3 }}
                >
                  No Clutch Details Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </>
  );
};

export default Myclutch;
